"use client"; 

import { ConsolidateFileModule } from '../../../modules/consolidate_files';
import { WrapMain } from '../../../../shared/modules/wrap_main'
import '../../../../styles/globalstyles.scss';

const index = () => {
  return (
    <WrapMain>
      <ConsolidateFileModule 
        title={'Monitoreo Optimización'} 
        instructions={[
          'Cargar las actividades del dia en formato excel',
          // 'Cargar el archivo .TAM del analizador',
          'Cargar las cartas de los distintos estudios en formato .txt',
          // 'Cargar cualquier otro archivo relacionado como fotos, odt u otros',
          // 'Inicialmente debes escoger la zona donde realizaste la actividad y agregar a todos los compañeros que han estado en la cuadrilla de trabajo' 
          ]} 
        templateUrl='https://docs.google.com/spreadsheets/d/18G0cW5YiPNGsMoC5GeV0C99bTODXJR3A/edit?usp=sharing&ouid=101890137215786227375&rtpof=true&sd=true'
        alertInstructions='Si ya ha cargado las actividades de la cuadrilla no vuelva a cargar los archivos puede editar la actividad anterior si esta no se ha iniciado a editar'
        />
    </WrapMain>
  )
}

export default index